import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.map";
import "core-js/modules/web.timers";

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/

/* eslint-disable no-new-func, wf-security/no-math-random */
import logger from '../logger/logger';

var initializeDesktop = function initializeDesktop(_ref) {
  var uri = _ref.uri,
      _ref$dt = _ref.dt,
      dt = _ref$dt === void 0 ? 'z_landing' : _ref$dt;
  var attributes = [['src', "".concat(uri, "?dt=").concat(dt, "&r=").concat(Math.random())], ['type', 'text/javascript'], ['async', true]];
  var element = document.createElement('script');
  setTimeout(function () {
    attributes.map(function (attribute) {
      return element.setAttribute(attribute[0], attribute[1]);
    });
    document.getElementsByTagName('head')[0].appendChild(element);
  }, 0);
};

var initializeMobile = function initializeMobile(_ref2) {
  var uri = _ref2.uri,
      sessionId = _ref2.sessionId,
      _ref2$dt = _ref2.dt,
      dt = _ref2$dt === void 0 ? 'z_m_landing' : _ref2$dt;
  var attributes = [['src', "".concat(uri, "?_m=").concat(sessionId, "&dt=").concat(dt, "&r=").concat(Math.random())], ['type', 'text/javascript'], ['async', true]];
  var element = document.createElement('script');
  setTimeout(function () {
    attributes.map(function (attribute) {
      return element.setAttribute(attribute[0], attribute[1]);
    });
    document.getElementsByTagName('head')[0].appendChild(element);
  }, 0);
};

export var initializeFraudDetection = function initializeFraudDetection(_ref3) {
  var uri = _ref3.uri,
      sessionId = _ref3.sessionId,
      _ref3$mobile = _ref3.mobile,
      mobile = _ref3$mobile === void 0 ? false : _ref3$mobile,
      dt = _ref3.dt;
  logger.debug('TRUSTEER: Initialize', uri, sessionId, mobile);
  return mobile ? initializeMobile({
    uri: uri,
    sessionId: sessionId,
    dt: dt
  }) : initializeDesktop({
    uri: uri,
    dt: dt
  });
};
export var setContext = function setContext(_ref4) {
  var context = _ref4.context;
  logger.debug("TRUSTEER: Setting context - ".concat(context));

  if (window['grip']) {
    window['grip'](context);
  } else {
    logger.debug('TRUSTEER: (ERROR) window.grip is not defined');
  }
};